import { Box } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { colors } from '../../const/colors'
import { LANGUAGES, currentLanguage, setLanguage } from '../../utils/language'

const LanguageSwitch = () => {
  const { t, i18n } = useTranslation(['admin_menu'])
  const active = currentLanguage(i18n.resolvedLanguage)

  return (
    <Box
      role="group"
      aria-label={t('admin_menu:language')}
      title={t('admin_menu:language')}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '2px',
        background: colors.bg,
        borderRadius: colors.radiusPill,
        p: '3px',
      }}
    >
      {LANGUAGES.map(language => {
        const isActive = language === active
        return (
          <Box
            key={language}
            component="button"
            type="button"
            onClick={() => setLanguage(language)}
            aria-pressed={isActive}
            data-e2e={`button-language-${language}`}
            sx={{
              border: 'none',
              font: 'inherit',
              px: '10px',
              height: 26,
              borderRadius: colors.radiusPill,
              fontSize: '12px',
              fontWeight: isActive ? 800 : 600,
              letterSpacing: '0.04em',
              cursor: isActive ? 'default' : 'pointer',
              background: isActive ? colors.navy : 'transparent',
              color: isActive ? '#fff' : colors.slate,
              transition: 'background .12s, color .12s',
              '&:hover': {
                color: isActive ? '#fff' : colors.navy,
              },
            }}
          >
            {language.toUpperCase()}
          </Box>
        )
      })}
    </Box>
  )
}

export default LanguageSwitch
